import React, { useState } from "react";
import axios from "axios";
import { Link,useNavigate } from "react-router-dom";

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setLoading(true);

    try {
      const response = await axios.post(`${API_BASE_URL}/register`, {
        email,
        password,
      });
      localStorage.setItem("token", response.data.token);
      navigate('/');
    } catch (err) {
      if (err.response && err.response.data) {
        if (err.response.data.args && Array.isArray(err.response.data.args)) {
          const validationErrors = err.response.data.args[0];
          setErrors(validationErrors);
        } else if (err.response.data.invalid) {
          setErrors({ ...errors, invalid: err.response.data.invalid });
        }
      } else {
        setErrors({ general: "An error occurred. Please try again later." });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      setEmail(value);
      setErrors((prevErrors) => ({ ...prevErrors, email: undefined }));
    } else if (name === "password") {
      setPassword(value);
      setErrors((prevErrors) => ({ ...prevErrors, password: undefined }));
    }
  };

  return (
    <div className="container">
      <div className="signup-page">
        <h2 className="text-center">Sign Up</h2>
        <div className="form">
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Work Email:</label>
              <div className="form-field">
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  value={email}
                  placeholder="Email"
                  onChange={handleChange}
                />
                {errors.email && (
                  <p className="error-message">{errors.email[0]}</p>
                )}
              </div>
            </div>
            <div className="form-group mt-3">
              <label>Password:</label>
              <div className="form-field">
                <input
                  type="password"
                  name="password"
                  value={password}
                  placeholder="Password"
                  onChange={handleChange}
                />
                {errors.password && (
                  <p className="error-message">{errors.password[0]}</p>
                )}
                {errors.invalid && (
                  <p className="error-message">{errors.invalid}</p>
                )}
              </div>
            </div>
            <div className="form-group form-btns mt-3">
              <div className="form-field">
                <button type="submit" disabled={loading} className="ls-btn">
                  {loading ? "Signing Up..." : "SIGN UP"}
                </button>
              </div>
            </div>
            <div>
              <p className="message">
                <Link to="/">Login to your account</Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
